export default __webpack_public_path__ + "static/media/avatar-worker.8fb39ebf.jpg";